import { RESET_STATE } from 'services/auth/constants';
import {
    RESET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION,
    REMOVE_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION,
    SET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION
} from './constants';
import {
    SelectedSprayEventIdsForSubmissionActions,
    SelectedSprayEventIdsForSubmissionState
} from './types';

const initialState: SelectedSprayEventIdsForSubmissionState = [];

export default function (
    state: SelectedSprayEventIdsForSubmissionState = initialState,
    action: SelectedSprayEventIdsForSubmissionActions
): SelectedSprayEventIdsForSubmissionState {
    switch (action.type) {
        case SET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION:
            return [...state, ...action.payload];
        case REMOVE_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION:
            return state.filter((id) => !action.payload.includes(id));
        case RESET_STATE:
        case RESET_SELECTED_SPRAY_EVENT_IDS_FOR_SUBMISSION:
            return initialState;
        default:
            return state;
    }
}
